// SPDX-License-Identifier: MIT
// Pure, DOM-free seams for the desktop code-push. The Rust side does the real
// git work ; these classify its output + drive the honest UI state.
import { supabase } from '../auth/supabase';

export type PushStatus =
  | 'pushed' | 'nothing-to-commit' | 'remote-ahead-pulled' | 'diverged'
  | 'no-git' | 'offline' | 'auth-failed' | 'error';

export interface GitResult { code: number; stderr: string; }

/** True si `git ls-remote` a renvoyé au moins une ref (repo non-vide). */
export function repoHasContent(lsRemoteStdout: string): boolean {
  return lsRemoteStdout.trim().length > 0;
}

/** Classe la sortie d'un push en un statut honnête pour l'UI. */
export function classifyPushResult(r: GitResult): PushStatus {
  const e = r.stderr.toLowerCase();
  if (r.code === 0) return 'pushed';
  if (e.includes('non-fast-forward') || e.includes('[rejected]')
      || e.includes('not possible to fast-forward') || e.includes('diverging')) return 'diverged';
  if (e.includes('authentication failed') || e.includes('403')) return 'auth-failed';
  if (e.includes('could not resolve host') || e.includes('unable to access') || e.includes('timed out')) return 'offline';
  if (e.includes('command not found') || e.includes('not recognized') || r.code === 127) return 'no-git';
  return 'error';
}

/** Demande un token write per-repo à l'edge fn (JWT). null si échec. */
export async function mintProjectWriteToken(projectId: string): Promise<string | null> {
  try {
    const { data, error } = await supabase.functions.invoke('forgejo-project-write-token', { body: { project_id: projectId } });
    if (error || !data?.token) return null;
    return data.token as string;
  } catch { return null; }
}
